<admin-panel-empty>
  <div class="row">
    <div style="width: 20%">
      <div class="text-muted text-lowercase small mb-1">{{'pages.results.cases.form.case' | translate}}</div>
      <div class="fw-bold text-dark"><input [(ngModel)]="query.id" id="case-value" type="text" class="mb-6 form-control border border-dark-3"></div>
    </div>
    <div style="width: 20%">
      <div class="text-muted text-lowercase small mb-1">{{'pages.results.cases.form.batch' | translate}}</div>
      <div class="fw-bold text-dark"><input [(ngModel)]="query.batch" id="case-value" type="text" class="mb-6 form-control border border-dark-3"></div>
    </div>
    <div style="width: 20%">
      <div class="text-muted text-lowercase small mb-1">{{'pages.results.cases.form.vertical' | translate}}</div>
      <div>
        <button class="btn dropdown-toggle btn-outline-purple rounded-1 btn-sm me-2 w-100 text-end" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          {{query.vertical ? query.vertical : 'select'}}
        </button>
        <ul class="dropdown-menu dropdown-menu-end bg-bg-3">
          <li><a class="dropdown-item" (click)="query.vertical = 'wlm'">wlm</a></li>
          <li><a class="dropdown-item" (click)="query.vertical = 'cdd'">cdd</a></li>
          <li><a class="dropdown-item" (click)="query.vertical = 'aml'">aml</a></li>
          <li><a class="dropdown-item" (click)="query.vertical = 'media'">media</a></li>
          <li><a class="dropdown-item" (click)="query.vertical = 'trade'">trade</a></li>
        </ul>
      </div>
    </div>
    <div style="width: 20%">
      <div class="text-muted text-lowercase small mb-1">{{'pages.results.cases.form.code' | translate}}</div>
      <div class="fw-bold text-dark"><input [(ngModel)]="query.code" id="case-value" type="text" class="mb-6 form-control border border-dark-3"></div>
    </div>
    <div style="width: 20%">
      <div class="text-muted text-lowercase small mb-1">{{'pages.results.cases.form.status' | translate}}</div>
      <div>
        <button class="btn dropdown-toggle btn-outline-purple rounded-1 btn-sm me-2 w-100 text-end" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          {{query.status ? query.status : 'select'}}
        </button>
        <ul class="dropdown-menu dropdown-menu-end bg-bg-3">
          <li><a class="dropdown-item" (click)="query.status = 'NEW'">new</a></li>
          <li><a class="dropdown-item" (click)="query.status = 'OPEN'">open</a></li>
          <li><a class="dropdown-item" (click)="query.status = 'CLOSED'">closed</a></li>
          <li><a class="dropdown-item" (click)="query.status = 'REPORTED'">reported</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="row">
    <div style="width: 20%">
      <div class="text-muted text-lowercase small mb-1">{{'pages.results.cases.form.record' | translate}}</div>
      <div class="fw-bold text-dark"><input [(ngModel)]="query.record" id="case-value" type="text" class="mb-6 form-control border border-dark-3"></div>
    </div>
    <div style="width: 20%">
      <div class="text-muted text-lowercase small mb-1">{{'pages.results.cases.form.data' | translate}}</div>
      <div>
        <button class="btn dropdown-toggle btn-outline-purple rounded-1 btn-sm me-2 w-100 text-end" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          {{query.data ? query.data : 'select'}}
        </button>
        <ul class="dropdown-menu dropdown-menu-end bg-bg-3">
          <li><a class="dropdown-item" (click)="query.data = 'entry'">entry</a></li>
          <li><a class="dropdown-item" (click)="query.data = 'event'">event</a></li>
          <li><a class="dropdown-item" (click)="query.data = 'request'">request</a></li>
          <li><a class="dropdown-item" (click)="query.data = 'customer'">customer</a></li>
          <li><a class="dropdown-item" (click)="query.data = 'account'">account</a></li>
          <li><a class="dropdown-item" (click)="query.data = 'transaction'">transaction</a></li>
        </ul>
      </div>
    </div>
    <div style="width: 20%">
      <div class="text-muted text-lowercase small mb-1">{{'pages.results.cases.form.report' | translate}}</div>
      <div class="fw-bold text-dark"><input [(ngModel)]="query.report" id="case-value" type="text" class="mb-6 form-control border border-dark-3"></div>
    </div>
    <div style="width: 20%">
      <div class="text-muted text-lowercase small mb-1">{{'pages.results.cases.form.entity' | translate}}</div>
      <div>
        <button class="btn dropdown-toggle btn-outline-purple rounded-1 btn-sm me-2 w-100 text-end" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          {{query.entity ? query.entity : 'select'}}
        </button>
        <ul class="dropdown-menu dropdown-menu-end bg-bg-3">
          <li><a class="dropdown-item" (click)="query.entity = 'entry'">entry</a></li>
          <li><a class="dropdown-item" (click)="query.entity = 'event'">event</a></li>
          <li><a class="dropdown-item" (click)="query.entity = 'request'">request</a></li>
          <li><a class="dropdown-item" (click)="query.entity = 'customer'">customer</a></li>
          <li><a class="dropdown-item" (click)="query.entity = 'account'">account</a></li>
          <li><a class="dropdown-item" (click)="query.entity = 'transaction'">transaction</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="row pt-5">
    <div class="col-12 text-end">
      <button (click)="reset()" class="btn btn-outline-third rounded-1 me-2" type="submit">{{'common.buttons.reset' | translate}}</button>
      <button (click)="search()" class="btn btn-first rounded-1" type="submit">{{'common.buttons.search' | translate}}</button>
    </div>
  </div>
</admin-panel-empty>
